import React from 'react'

import { useSelector } from 'react-redux'

import { MenuExperiencePage } from 'routes/Menu/MenuExperience/MenuExperiencePage'
import { MenuPage } from 'routes/Menu/MenuExperience/MenuPage'
import { MenuRecipesPageWrapper } from 'routes/Menu/MenuRecipesPage'
import { useIsMenuExperiencePageEnabled } from 'routes/Menu/domains/menu'
import { getIsAuthenticated } from 'selectors/auth'

type MenuRouterProps = {
  params: {
    orderId?: string
  }
  location: {
    query: Record<string, unknown>
  }
}

export const MenuRouter = ({ params, location }: MenuRouterProps) => {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const isMenuExperiencePageEnabled = useIsMenuExperiencePageEnabled()

  if (isAuthenticated) {
    if (isMenuExperiencePageEnabled) {
      return <MenuExperiencePage params={params} location={location} />
    }

    return <MenuPage params={params} location={location} />
  }

  return <MenuRecipesPageWrapper params={params} location={location} />
}
